import authenticationMod from '@dfl/react-auth-module/locale/es/authentication.json';
import dflcms from '@dfl/react-cms/locale/es/dflcms.json';

import activityPlace from './activityPlace';
import actors from './actors';
import admin from './admin';
import alert from './alert';
import authenticationLocal from './authentication';
import bankSyncProcess from './bankSyncProcess';
import category from './category';
import commercialRegister from './commercialRegister';
import common from './common';
import company from './company';
import configuration from './configuration';
import dashboard from './dashboard';
import dpjOffice from './dpjOffice';
import forms from './forms';
import historian from './historian';
import navigation from './navigation';
import notary from './notary';
import notifications from './notifications';
import onatFiles from './onatFiles';
import permissions from './permissions';
import profile from './profile';
import proposalFiles from './proposalFiles';
import proposalRequest from './proposalRequest';
import protectedArea from './protectedArea';
import table from './table';
import tools from './tools';
import verification from './verification';

const authentication = {
  ...authenticationMod,
  ...authenticationLocal
};

export {
  activityPlace,
  actors,
  admin,
  alert,
  authentication,
  bankSyncProcess,
  category,
  commercialRegister,
  common,
  company,
  configuration,
  dashboard,
  dflcms,
  dpjOffice,
  forms,
  historian,
  navigation,
  notary,
  notifications,
  onatFiles,
  permissions,
  profile,
  proposalFiles,
  proposalRequest,
  protectedArea,
  table,
  tools,
  verification
};
